import axios from "axios";
import config from "config";
import { UserBU, UserGroup } from "constants/UserConstants";
import { getBusinessUnit, getGroup } from "utils/Common";
import keycloak from "keycloak";

const { API_BASE_URL } = config;

export const pvBaseURL = API_BASE_URL;
export const cvServiceBaseURL = API_BASE_URL + "/cv";
export const cvSalesBaseURL = API_BASE_URL + "/cv/sales";
export const cvFleetEdgeWebsocketApiBaseURL = API_BASE_URL + "/cv/fleet-edge";

export const getBaseURL = () => {
  const businessUnit = getBusinessUnit();
  const group = getGroup();
  let apiBaseURL = pvBaseURL;
  if (businessUnit === UserBU.CV) {
    apiBaseURL = cvServiceBaseURL;
    if (group === UserGroup.SALES) {
      apiBaseURL = cvSalesBaseURL;
    }
  }

  return apiBaseURL;
};

export const uepClient = (additionalOptions = {}, headers = {}) => {
  const defaultOptions = {
    baseURL: getBaseURL(),
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };

  // Create instance
  let instance = axios.create({ ...defaultOptions, ...additionalOptions });

  // Add AUTH token to request
  instance.interceptors.request.use(function (config) {
    const token = keycloak.token;
    if (!config.headers.Authorization) {
      config.headers.Authorization = token ? `Bearer ${token}` : "";
    }
    return config;
  });

  return instance;
};
